<template>
    <router-link :to="{ name: 'detail', params: { id: item.pk } }" class="element"
        :class="{ mobileArchive: onArchive && $mq == 'sm', first }">
        <img :src="item.thumbnail" id="postIt" alt="" :class="[
            { mobileArchive: onArchive && $mq == 'sm' },
            item.category,
        ]" />
        <div id="textWrapper" :class="{ mobileArchive: onArchive && $mq == 'sm' }">
            <div v-if="
                ($mq != 'sm' || !onArchive) && (item.has_audio || item.url) && itemIsPast
            ">
                <img v-if="isPlaying(item.pk, item.type)" @click.stop.prevent="setPause" id="pause" class="button" :src="pauseHover
                    ? '/static/new_icons/pause-player_hover.svg'
                    : '/static/icons/pause-player.svg'
                    " @mouseover="pauseHover = true" @mouseout="pauseHover = false" />

                <img v-else :src="playHover
                    ? '/static/new_icons/play-player-large_hover.svg'
                    : '/static/icons/play-player-large.svg'
                    " class="button" @click.stop.prevent="setPlay" id="play" @mouseover="playHover = true"
                    @mouseout="playHover = false" />
            </div>
            <div v-if="first == false" id="text" :class="{ mobileArchive: onArchive && $mq == 'sm' }">
                <!-- <p v-if="live && !isArchive" id="time">{{ formattedTime }}</p> -->
                <!-- <p v-else-if="!isArchive" id="time">{{ formatDuration }}</p> -->
                <!-- <p v-else id="date">{{ formatDate }}</p> -->
                <template v-if="onSchedule">
                    <p class="scheduleTime">
                        <span id="date">{{ formatScheduleDate }}</span>
                        <span v-html="getFormattedTime(item)"> </span>
                    </p>
                    <div>
                        <p v-if="item.artist && item.title" id="artist">{{ item.artist }}: {{ item.title }}</p>
                        <p v-else-if="item.artist && !item.title" id="artist">{{ item.artist }}</p>
                        <p v-else-if="!item.artist && item.title" id="artist">{{ item.title }}</p>
                    </div>

                    <p class="scheduleLocationContainer">
                        <span class="scheduleLocation" v-if="item.show_location_live">
                            Live at {{ item.venue }}, {{ item.city }}
                        </span>
                    </p>
                </template>
                <template v-else-if="onSeries">
                    <p class="scheduleTime">
                        <span id="date">{{ formatDate }}</span>
                    </p>
                    <div>
                        <p v-if="item.artist && item.title" id="artist">{{ item.artist }}: {{ item.title }}</p>
                        <p v-else-if="item.artist && !item.title" id="artist">{{ item.artist }}</p>
                        <p v-else-if="!item.artist && item.title" id="artist">{{ item.title }}</p>
                    </div>
                </template>

                <template v-else>
                    <div>
                        <p id="artist">{{ item.artist }}</p>
                        <p id="title">{{ item.title }}</p>
                    </div>

                    <p id="location">
                        <span id="date">{{ formatDate }}</span>
                        <span v-if="item.venue">{{ item.venue }}</span>
                        <span v-if="item.city">{{ item.city }}</span>
                    </p>
                </template>
            </div>

            <!-- <div v-if="isArchive && (item.has_audio || item.url) && $mq == 'sm'" id="smallPlayContainer"> -->
            <!--     <img v-if="isPlaying(item.pk, item.type)" :src="pauseHover -->
            <!--         ? '/static/new_icons/pause-player-small_hover.svg' -->
            <!--         : '/static/new_icons/pause-player-small.svg' -->
            <!--         " class="button pause mobile" @click.stop.prevent="setPause" id="pause" -->
            <!--         @mouseover="pauseHover = true" @mouseout="pauseHover = false" /> -->
            <!--     <img v-else :src="playHover -->
            <!--         ? '/static/new_icons/play-player-small_hover.svg' -->
            <!--         : '/static/icons/play-player-small.svg' -->
            <!--         " class="button play mobile" @click.stop.prevent="setPlay" id="play" @mouseover="playHover = true" -->
            <!--         @mouseout="playHover = false" /> -->
            <!-- </div> -->

            <div id="buttons">
                <img v-if="isArchive && item.has_audio && !inPlaylist" :src="addHover
                    ? '/static/new_icons/add_hover.svg'
                    : '/static/icons/add.svg'
                    " class="button add" @click.stop.prevent="addToList" id="add" @mouseover="addHover = true"
                    @mouseout="addHover = false" />



                <template v-if="isArchive && onArchive">
                    <img v-if="!store.authenticated"
                        :src="likeHover ? '/static/Favorite_Hover.svg' : '/static/Favorite.svg'"
                        @mouseover="likeHover = true" @mouseout="likeHover = false" class="button add"
                        @click.prevent.stop="store.showLikePopup = true">
                    <img v-else-if="store.likes.some(i => i == item.pk) || liked == true"
                        @click.prevent.stop="removeLike" src="/static/Favorite_Hover.svg" class="button add"
                        @mouseout="likeHover = false">
                    <img v-else @click.prevent.stop="addLike"
                        :src="likeHover ? '/static/Favorite_Hover.svg' : '/static/Favorite.svg'"
                        @mouseover="likeHover = true" @mouseout="likeHover = false" class="button add">
                </template>
            </div>

            <!-- <button v-if="store.authenticated" -->
            <!--     @click.stop.prevent="store.likes.some(i => i == item.pk) ? removeLike() : addLike()" id="addLike" -->
            <!--     :class="{ liked: store.likes.some(i => i == item.pk) || liked == true }">Like</button> -->
        </div>
    </router-link>
</template>

<script>
import { store } from "../store";
import { DateTime, Duration } from "luxon";
import axios from "axios";

export default {
    name: "Element",
    props: [
        "item",
        "isArchive",
        "onArchive",
        "index",
        "first",
        "live",
        "isPick",
        "onSchedule",
        "onSeries",
    ],
    data() {
        return {
            store: store,
            addHover: false,
            playHover: false,
            pauseHover: false,
            liked: false,
            likeHover: false,
        };
    },
    computed: {
        itemIsPast() {

            if (this.item.timezone == '0' || this.item.timezone == null) {
                return true
            }
            let aware = DateTime.fromISO(this.item.start_time, {
                zone: this.item.timezone,
            });

            let utc = aware.toUTC();

            return utc.valueOf() < DateTime.utc().valueOf();

        },
        itemIsCurrentSeries() {
            if (this.item.all_series.length >= 1) {
                if (this.item.series.some(s => s.slug == this.item.all_series[0].slug)) {
                    if (this.itemIsPast) {
                        return true
                    } else {
                        return false
                    }
                } else if (this.item.series.some(s => s.slug == this.item.all_series[1].slug)) {
                    if (DateTime.fromISO(this.item.all_series[0].earliest_item) < DateTime.now()) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }

            } else {
                return false
            }
        },
        formatDate() {
            return DateTime.fromISO(this.item.start_time, { zone: this.item.timezone })
                .setLocale("en-US")
                .toFormat("MM/dd/yy");
        },
        formatScheduleDate() {
            let aware = DateTime.fromISO(this.item.start_time, { zone: this.item.timezone })
                .setLocale("en-US")

            let local = aware.setZone("local");
            return local.toFormat("MM/dd/yy");
        },
        formatDuration() {
            return Duration.fromObject({
                seconds: this.item.duration,
            }).toFormat("hh:mm:ss");
        },
        formattedTime() {
            return DateTime.fromISO(this.item.start_time)
                .setLocale("en-US")
                .toFormat("hh:mm a");
        },
        inPlaylist() {
            return this.store.playlist.items.some((e) => e.pk == this.item.pk);
        },
    },
    methods: {
        getFormattedTime(item) {
            let aware = DateTime.fromISO(item.start_time, {
                zone: item.timezone,
            }).setLocale("en-US");
            // console.log(aware.zoneName);
            let local = aware.setZone("local");

            if (aware.offset != local.offset) {
                return `${local.toFormat("hh:mm")}&thinsp;${local.toFormat(
                    "a"
                )}&ensp;(${aware.toFormat("hh:mm")}&thinsp;${aware.toFormat(
                    "a"
                )}&ensp;${item.city})`;
            } else {
                return `${aware.toFormat("hh:mm")}&thinsp;${aware.toFormat(
                    "a"
                )}`;
            }
        },

        addLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/add-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = true
                        myself.store.likes.push(response.data.like)
                        localStorage.setItem("likes", JSON.stringify(myself.store.likes));
                        myself.liked = false
                    }

                })

        },
        removeLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/remove-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = false
                        myself.store.likes = myself.store.likes.filter(l => l != response.data.like)
                        localStorage.setItem("likes", JSON.stringify(myself.store.likes));
                    }

                })

        },

        isPlaying(pk, type) {
            if (
                store.privatePlayerItem.type == type &&
                store.privatePlayerItem.pk == pk &&
                store.privatePlayerStatus == "playing"
            ) {
                return true;
            }
        },
        setPlay() {
            if (this.store.valid || this.isPick || this.itemIsCurrentSeries) {
                this.store.privatePlayerItem = this.item;
                this.store.privatePlayerVisible = true;
                this.store.privatePlayerChanged = true;
                // setTimeout(function() {
                this.store.privatePlayerStatus = "unpaused";
                // }, 200);
                // this.store.privatePlayerStatus = "paused";
            } else {
                this.store.showSupportPopup = true;
            }
            this.playHover = false;
            //let myself = this;
            //setTimeout(function(){
            //myself.store.privatePlayerStatus = 'startplaying';
            //}, 1000)
        },
        setPause() {
            this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
        },

        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        addToList() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/add-task", {
                    //title: myself.item.title,
                    //artist: myself.item.artist,
                    //url: myself.item.audio,
                    //duration: myself.item.duration,
                    //thumbnail: myself.item.thumbnail,
                    //image: myself.item.image,
                    pk: myself.item.pk,
                    //category: myself.item.category,
                    //venue: myself.item.venue,
                    //city: myself.item.city,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.store.listFull = false;

                        axios.get("/api/get-tasks").then((response) => {
                            myself.store.playlist = response.data.playlist;
                            myself.store.streams = response.data.streams;
                        });
                    } else if (response.data.message == "listFull") {
                        myself.store.listFull = true;
                    }
                    myself.store.showAddPopup = true;
                });
        },
    },
};
</script>

<style scoped>
.element {
    display: grid;
    padding: 0;
    /* align-content: start; */
    /* align-items: start; */
}

.element.mobileArchive {
    display: flex;
    flex-direction: row;
    font-family: "Montez Small";
    font-size: 1rem;
    min-width: 0;
    gap: 1rem;
    align-items: center;
}

/* @media only screen and (min-width: 738px) { */
/*     .element { */
/*         width: auto; */
/*     } */
/* } */

/* @media only screen and (min-width: 1101px) { */
/*     .element { */
/*         width: auto; */
/*     } */
/* } */

/* @media only screen and (min-width: 1440px) { */
/*     .element { */
/*         width: auto; */
/*     } */
/* } */

/* @media only screen and (min-width: 1900px) { */
/*     .element { */
/*         width: auto; */
/*     } */
/* } */

p {
    margin: 0;
}

.element>img {
    transition: transform 0.2s;
}

/* .element:not(.first):hover > img{ */
.element:hover>img {
    transform: scale(1.02);
}

img {
    /* max-height: 100%; */
    max-width: 100%;
    /* min-height: 100%; */
    /* min-width: 100%; */
    /* object-fit: cover; */
    background-color: #d2d2d2;
    aspect-ratio: 1 / 1;
    height: 100%;
}

img.LI {
    background-color: #8dd9fc;
}

img.IS {
    background-color: #f6b2c6;
}

img.IR {
    background-color: #f6b2c6;
}

img.RE {
    background-color: #9fe1a7;
}

img.NY {
    background-color: #fcfac4;
}

img.IN {
    background-color: #B0A4E4;
}

/* @media only screen and (min-width: 738px) { */
/*     img { */
/*         min-height: calc(50vw - 2rem); */
/*         min-width: calc(50vw - 2rem); */
/*     } */
/* } */

/* @media only screen and (min-width: 1101px) { */
/*     img { */
/*         min-height: calc(33.3vw - 2rem); */
/*         min-width: calc(33.3vw - 2rem); */
/*     } */
/* } */

/* @media only screen and (min-width: 1440px) { */
/*     img { */
/*         min-height: calc(25vw - 2rem); */
/*         min-width: calc(25vw - 2rem); */
/*     } */
/* } */

/* @media only screen and (min-width: 1900px) { */
/*     img { */
/*         min-height: calc(20vw - 2rem); */
/*         min-width: calc(20vw - 2rem); */
/*     } */
/* } */

img#postIt.mobileArchive {
    height: 51px;
    width: 51px;
}

img#postIt {
    max-width: unset;
    width: 100%;
    height: auto;
}

img.button {
    height: 3rem;
    min-height: unset;
    min-width: unset;
    max-height: unset;
    max-width: unset;
    background-color: transparent;
}

img.button.add,
img.button.pause.mobile,
img.button.play.mobile {
    height: 1.7rem;
    display: block;
    /* align-self: flex-start; */
}

#smallPlayContainer {
    /* align-self: flex-start; */
}

#play,
#pause,
#add {
    cursor: pointer;
}

#location span:first-child {
    /* margin-right: 1rem; */
}

#location {
    /*color: #aaaaaa;*/
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    font-family: "Montez Small";
    display: flex;
    gap: 1rem;
}

.scheduleLocation {
    font-family: "Montez Small";
    font-size: 12px;
    border: 1px solid black;
    border-radius: 2rem;
    display: inline;
    padding: 0px 0.6rem 2px;
    align-self: flex-start;
    margin-top: 0.5rem !important;
}

.scheduleLocationContainer {
    min-height: 2.5rem;
    display: flex;
    flex-direction: column;
}

#date {
    /* font-variant-numeric: tabular-nums; */
    font-feature-settings: "case" on;
    /* font-variant-caps: all-small-caps; */
}

#text {
    flex-grow: 1;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.583rem;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

@media only screen and (min-width: 738px) {
    #text {
        line-height: 1.667rem;
        /* height: 4.5rem; */
    }
}

#text.mobileArchive {
    margin: 0;
    line-height: 1.167rem;
    margin-right: 0.5rem;
}

#artist,
#title {
    text-overflow: ellipsis;
    overflow: hidden;
}

@media only screen and (min-width: 738px) {
    #title {
        /*padding-bottom: 3px;*/
    }
}

#textWrapper {
    display: flex;
    align-items: center;
    min-width: 0;
    flex-grow: 1;
    gap: 1rem;
    margin-top: 0.7rem;
}

#textWrapper.mobileArchive {
    margin-top: 0;
    gap: 0.5rem;
}

@media only screen and (min-width: 738px) {
    #textWrapper {
        gap: 1rem;
        margin-left: 0;
    }
}

#functions {
    display: flex;
}

#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
}

#addLike.liked {
    color: red;
}

#buttons {
    display: flex;
    gap: 4px;
}

.scheduleTime {
    display: flex;
    gap: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* font-family: "Montez Small"; */
    /* font-size: 12px; */
}
</style>
